<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="cardResourcesParam" class="demo-form-inline">
        <el-form-item label="卡片名称">
          <el-input v-model="cardResourcesParam.merCardName" placeholder="请输入卡片名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="cardResourcesParam.state" placeholder="请选择状态" clearable>
            <el-option label="正常" value="0"></el-option>
            <el-option label="下架" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button icon="el-icon-delete" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加</el-button>
      <el-button size="small" @click="editClick" :disabled="selectedRows.length != 1" type="primary">修改</el-button>
      <el-button size="small" :underline="false" type="danger" :disabled="!selectedRows.length" @click="delCardResources" icon="el-icon-delete-solid">删除</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table ref="selections" size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="merCardName" label="卡片名称"></el-table-column>
          <el-table-column prop="firstPayAmount" label="首刷"></el-table-column>
          <el-table-column prop="nuclearCardAmount" label="核卡"></el-table-column>
          <el-table-column prop="settlementDays" label="结算周期（天）"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 0">正常</span>
              <span v-if="scope.row.state == 1">下架</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                     :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                     :total="totalDataNumber"></el-pagination>
    </div>

    <Add :open="open_add" @close="closeAdd"></Add>
    <Edit :open="open_edit" @close="closeEdit" :editform="selectedRows[0]"></Edit>
  </div>
</template>
<script>

import CardResourcesApi from '@/api/cardresources.js';
import Add from './dialog/Add.vue';
import Edit from "./dialog/Edit.vue";
export default {
  components: {
    /*编辑组件*/
    Add,
    Edit
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*全选/单选*/
      selectedRows: [],
      /*横向表单数据模型*/
      cardResourcesParam: {
        merCardName: '',
        state: null
      },
      /*一页多少条*/
      pageSize: 10,
      pagelndex: 1, // 页数
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.cardResourcesParam;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      CardResourcesApi.cardResourcesSelectList(Params, true)
        .then(res => {
          self.loading = false;
          this.totalDataNumber = res.data.total
          self.tableData = res.data.records;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开编辑*/
    editClick() {
      this.open_edit = true;
    },
    // 删除
    delCardResources() {
      if (this.selectedRows.length !== 0) {
        const ids = this.selectedRows.map(row => row.id);
        const params = ids.join(',')
        this.$confirm('是否确认删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          CardResourcesApi.delete({idList: params}).then(res => {
            // console.log(res)
            this.loading = false;
            this.bannerListFunc()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(err => {
            this.getData();
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.getData();
        });

      }
    },

    /*搜索查询*/
    onSubmit() {
      this.getData();
    },
    /*重置*/
    reset() {
      this.curPage = 1;
      this.cardResourcesParam.merCardName = '';
      this.cardResourcesParam.state = '';
      this.getData();
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.open_add=true;
    },
    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getData();
      }
    },
    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      if(e.type=='success'){
        this.getData();
      }
    },
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/cardapply/cardresources/index.vue